// if you're using a bundler, first import:
import Headroom from "headroom.js";

const HeaderScroll = () => {

    // Header element
    const headerElement = document.querySelector('.header');
    // Mobile menu selector
    const mobileMenu = document.querySelector('.mobile-menu');
    // Modifier class for the scrolled menu state
    const scrolledClass = 'header--scrolled';
    // Modifier for the scrolled mobile menu state
    const mobileClass = 'mobile-menu--scrolled';

    // Add or remove classes based on the user scrolling down the page
    window.addEventListener('scroll', () => {

        const current_scroll = window.pageYOffset;

        if (current_scroll > 0) {
            headerElement.classList.add(scrolledClass);

            if (typeof mobileMenu != 'undefined' && mobileMenu) {
                mobileMenu.classList.add(mobileClass);
            }
        } else {
            headerElement.classList.remove(scrolledClass);

            if (typeof mobileMenu != 'undefined' && mobileMenu) {
                mobileMenu.classList.remove(mobileClass);
            }
        }
    });

    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom(headerElement);
    // initialise
    headroom.init();
}

export default HeaderScroll;
